import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import { toViewDate } from '../../../../helpers/formatter/dateFormatters'
import { useReports } from '../../Context/ReportsContext'
import { useCohorts } from '../../Hooks/useCohorts'

export const CourseCohortsSelect = () => {
    const { t } = useTranslation('teamReports')
    const { optionsSelected, setOptionsSelected } = useReports()
    const { cohorts } = useCohorts()
    const options = cohorts?.map((cohort) => {
        return { label: toViewDate(cohort), value: toViewDate(cohort) }
    })

    if (cohorts.length === 1) {
        return null
    }

    return (
        <div className="cohort-header">
            <Select
                onChange={(values) => setOptionsSelected(values)}
                defaultValue={optionsSelected}
                isMulti
                isSearchable
                options={options}
                placeholder={t('All Cohorts')}
                noOptionsMessage={() => t('No options')}
            ></Select>
        </div>
    )
}
